import Commons from '@/shared/utils/commons.js';
import { FcmNotification } from '@/shared/utils/fcmNotification.js';

class NotificationService {
  async getDeviceToken() {
    let token = null;
    if (Commons.isCapacitor()) {
      token = await this.getCapacitorDeviceToken();
    } else if ('Notification' in window) {
      FcmNotification.init();
      try {
        const perm = await Notification.requestPermission();
        if (perm === 'granted') {
          token = await FcmNotification.getDeviceToken();
        }
      } catch (e) {
        console.error(e);
      }
    }
    console.log('🚀 ~ NotificationService ~ getDeviceToken ~ token:', token);
    return token;
  }

  async getCapacitorDeviceToken() {
    return new Promise((resolve) => {
      const requestId = Commons.generateUUID();
      const responseHandler = (event) => {
        if (
          event.data?.type === 'DEVICE_TOKEN_RESPONSE' &&
          event.data.requestId === requestId
        ) {
          window.removeEventListener('message', responseHandler);
          resolve(event.data.token);
        }
      };

      window.addEventListener('message', responseHandler);

      try {
        window.parent.postMessage(
          {
            type: 'REQUEST_DEVICE_TOKEN',
            requestId: requestId
          },
          '*'
        );
      } catch (error) {
        window.removeEventListener('message', responseHandler);
        console.log('🚀 ~ Commons ~ getDeviceToken ~ error:', error);
        resolve(null);
      }

      // Timeout après 3 secondes
      setTimeout(() => {
        window.removeEventListener('message', responseHandler);
        resolve(null);
      }, 3000);
    });
  }

  async uploadDeviceToken(userId, token) {
    if (!userId || !token) return;

    const requestId = `device-token-${Date.now().toString(36)}${Math.floor(Math.random() * 100000)}`;

    const payload = {
      token: token,
      userId: userId,
      requestId,
      service: 'rapidoo-rider' // specific service for rider
    };

    console.log('[NotificationService] Uploading device token...', payload);

    fetch(
      'https://api.monrapidoo.com/queue/broadcast/data/rapidoo-transactions/addToken?group=commons',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    ).catch((err) => {
      console.error('[NotificationService] uploadDeviceToken error:', err);
    });
  }

  async sendPushNotification({ userId, title, content, service = 'rapidoo' }) {
    if (!userId) return null;
    const payload = {
      userId,
      title,
      content,
      service
    };
    try {
      const response = await fetch('https://api.monrapidoo.com/notification/send?group=ultraxeno', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      return await response.json();
    } catch (err) {
      console.error('[NotificationService] sendPushNotification error:', err);
      return null;
    }
  }

  async notifyCustomerProximity(delivery) {
    if (!delivery) return;
    const customerId = delivery.customerId || delivery.userId;
    if (!customerId) return;

    const deliveryId = delivery.id || delivery.deliveryCode || delivery.orderReference || delivery.reference;
    const key = `proximity_notif_${deliveryId}`;
    if (localStorage.getItem(key)) {
      return; // déjà notifié pour cette livraison
    }

    localStorage.setItem(key, 'true');
    console.log('[NotificationService] Envoi notification proximité client (< 3 min):', customerId);

    return this.sendPushNotification({
      userId: customerId,
      title: 'Livreur à proximité',
      content: 'Votre livreur est à moins de 3 minutes de vous. Préparez-vous à le recevoir !',
      service: 'rapidoo'
    });
  }
}

export const notificationService = new NotificationService();
